// extracted by mini-css-extract-plugin
module.exports = {"align":"styles_align__3bz9b"};